import { initiateOurStructureSelection } from './our-structure.lib'

import { DOMReadyP } from '@app-helpers'

DOMReadyP.then(() => {
    initiateOurStructureSelection()
})
